import { useStore } from "../../stores/StoreContext";
import { CurrentUserService } from "../LogicServices/CurrentUserService";

export function useCurrentUserService(): CurrentUserService {
  const storeContext = useStore();
  return new CurrentUserService(storeContext);
}
